import { ChannelFreqObject } from 'src/app/models/ChannelFreqObject';

export class FreqConversionUtil {
  public static channelFreqList : ChannelFreqObject[] = [
    new ChannelFreqObject("1X", null, 962.0, 1025.0,null),
		new ChannelFreqObject("1Y", null, 1088.0, 1025.0,null),
		new ChannelFreqObject("2X", null, 963.0, 1026.0,null),
		new ChannelFreqObject("2Y", null, 1089.0, 1026.0,null),
		new ChannelFreqObject("3X", null, 964.0, 1027.0,null),
		new ChannelFreqObject("3Y", null, 1090.0, 1027.0,null),
		new ChannelFreqObject("4X", null, 965.0, 1028.0,null),
		new ChannelFreqObject("4Y", null, 1091.0, 1028.0,null),
		new ChannelFreqObject("5X", null, 966.0, 1029.0,null),
		new ChannelFreqObject("5Y", null, 1092.0, 1029.0,null),
		new ChannelFreqObject("6X", null, 967.0, 1030.0,null),
		new ChannelFreqObject("6Y", null, 1093.0, 1030.0,null),
		new ChannelFreqObject("7X", null, 968.0, 1031.0,null),
		new ChannelFreqObject("7Y", null, 1094.0, 1031.0,null),
		new ChannelFreqObject("8X", null, 969.0, 1032.0,null),
		new ChannelFreqObject("8Y", null, 1095.0, 1032.0,null),
		new ChannelFreqObject("9X", null, 970.0, 1033.0,null),
		new ChannelFreqObject("9Y", null, 1096.0, 1033.0,null),
		new ChannelFreqObject("10X", null, 971.0, 1034.0,null),
		new ChannelFreqObject("10Y", null, 1097.0, 1034.0,null),
		new ChannelFreqObject("11X", null, 972.0, 1035.0,null),
		new ChannelFreqObject("11Y", null, 1098.0, 1035.0,null),
		new ChannelFreqObject("12X", null, 973.0, 1036.0,null),
		new ChannelFreqObject("12Y", null, 1099.0, 1036.0,null),
		new ChannelFreqObject("13X", null, 974.0, 1037.0,null),
		new ChannelFreqObject("13Y", null, 1100.0, 1037.0,null),
		new ChannelFreqObject("14X", null, 975.0, 1038.0,null),
		new ChannelFreqObject("14Y", null, 1101.0, 1038.0,null),
		new ChannelFreqObject("15X", null, 976.0, 1039.0,null),
		new ChannelFreqObject("15Y", null, 1102.0, 1039.0,null),
		new ChannelFreqObject("16X", null, 977.0, 1040.0,null),
		new ChannelFreqObject("16Y", null, 1103.0, 1040.0,null),
		new ChannelFreqObject("17X", 108.0, 978.0, 1041.0,'VOR'),
		new ChannelFreqObject("17Y", 108.05, 1104.0, 1041.0,'VOR'),
		new ChannelFreqObject("18X", 108.1, 979.0, 1042.0,'DME_ILS'),
		new ChannelFreqObject("18Y", 108.15, 1105.0, 1042.0,'DME_ILS'),
		new ChannelFreqObject("19X", 108.2, 980.0, 1043.0,'VOR'),
		new ChannelFreqObject("19Y", 108.25, 1106.0, 1043.0,'VOR'),
		new ChannelFreqObject("20X", 108.3, 981.0, 1044.0,'DME_ILS'),
		new ChannelFreqObject("20Y", 108.3, 1107.0, 1044.0,'DME_ILS'),
		new ChannelFreqObject("21X", 108.4, 982.0, 1045.0,'VOR'),
		new ChannelFreqObject("21Y", 108.45, 1108.0, 1045.0,'VOR'),
		new ChannelFreqObject("22X", 108.5, 983.0, 1046.0,'DME_ILS'),
		new ChannelFreqObject("22Y", 108.55, 1109.0, 1046.0,'DME_ILS'),
		new ChannelFreqObject("23X", 108.6, 984.0, 1047.0,'VOR'),
		new ChannelFreqObject("23Y", 108.65, 1110.0, 1047.0,'VOR'),
		new ChannelFreqObject("24X", 108.7, 985.0, 1048.0,'DME_ILS'),
		new ChannelFreqObject("24Y", 108.75, 1111.0, 1048.0,'DME_ILS'),
		new ChannelFreqObject("25X", 108.8, 986.0, 1049.0,'VOR'),
		new ChannelFreqObject("25Y", 108.85, 1112.0, 1049.0,'VOR'),
		new ChannelFreqObject("26X", 108.9, 987.0, 1050.0,'DME_ILS'),
		new ChannelFreqObject("26Y", 108.95, 1113.0, 1050.0,'DME_ILS'),
		new ChannelFreqObject("27X", 109.0, 988.0, 1051.0,'VOR'),
		new ChannelFreqObject("27Y", 109.05, 1114.0, 1051.0,'VOR'),
		new ChannelFreqObject("28X", 109.1, 989.0, 1052.0,'DME_ILS'),
		new ChannelFreqObject("28Y", 109.15, 1115.0, 1052.0,'DME_ILS'),
		new ChannelFreqObject("29X", 109.2, 990.0, 1053.0,'VOR'),
		new ChannelFreqObject("29Y", 109.25, 1116.0, 1053.0,'VOR'),
		new ChannelFreqObject("30X", 109.3, 991.0, 1054.0,'DME_ILS'),
		new ChannelFreqObject("30Y", 109.35, 1117.0, 1054.0,'DME_ILS'),
		new ChannelFreqObject("31X", 109.4, 992.0, 1055.0,'VOR'),
		new ChannelFreqObject("31Y", 109.45, 1118.0, 1055.0,'VOR'),
		new ChannelFreqObject("32X", 109.5, 993.0, 1056.0,'DME_ILS'),
		new ChannelFreqObject("32Y", 109.55, 1119.0, 1056.0,'DME_ILS'),
		new ChannelFreqObject("33X", 109.6, 994.0, 1057.0,'VOR'),
		new ChannelFreqObject("33Y", 109.65, 1120.0, 1057.0,'VOR'),
		new ChannelFreqObject("34X", 109.7, 995.0, 1058.0,'DME_ILS'),
		new ChannelFreqObject("34Y", 109.75, 1121.0, 1058.0,'DME_ILS'),
		new ChannelFreqObject("35X", 109.8, 996.0, 1059.0,'VOR'),
		new ChannelFreqObject("35Y", 109.85, 1122.0, 1059.0,'VOR'),
		new ChannelFreqObject("36X", 109.9, 997.0, 1060.0,'DME_ILS'),
		new ChannelFreqObject("36Y", 109.95, 1123.0, 1060.0,'DME_ILS'),
		new ChannelFreqObject("37X", 110.0, 998.0, 1061.0,'VOR'),
		new ChannelFreqObject("37Y", 110.05, 1124.0, 1061.0,'VOR'),
		new ChannelFreqObject("38X", 110.1, 999.0, 1062.0,'DME_ILS'),
		new ChannelFreqObject("38Y", 110.15, 1125.0, 1062.0,'DME_ILS'),
		new ChannelFreqObject("39X", 110.2, 1000.0, 1063.0,'VOR'),
		new ChannelFreqObject("39Y", 110.25, 1126.0, 1063.0,'VOR'),
		new ChannelFreqObject("40X", 110.3, 1001.0, 1064.0,'DME_ILS'),
		new ChannelFreqObject("40Y", 110.35, 1127.0, 1064.0,'DME_ILS'),
		new ChannelFreqObject("41X", 110.4, 1002.0, 1065.0,'VOR'),
		new ChannelFreqObject("41Y", 110.45, 1128.0, 1065.0,'VOR'),
		new ChannelFreqObject("42X", 110.5, 1003.0, 1066.0,'DME_ILS'),
		new ChannelFreqObject("42Y", 110.55, 1129.0, 1066.0,'DME_ILS'),
		new ChannelFreqObject("43X", 110.6, 1004.0, 1067.0,'VOR'),
		new ChannelFreqObject("43Y", 110.65, 1130.0, 1067.0,'VOR'),
		new ChannelFreqObject("44X", 110.7, 1005.0, 1068.0,'DME_ILS'),
		new ChannelFreqObject("44Y", 110.75, 1131.0, 1068.0,'DME_ILS'),
		new ChannelFreqObject("45X", 110.8, 1006.0, 1069.0,'VOR'),
		new ChannelFreqObject("45Y", 110.85, 1132.0, 1069.0,'VOR'),
		new ChannelFreqObject("46X", 110.9, 1007.0, 1070.0,'DME_ILS'),
		new ChannelFreqObject("46Y", 110.95, 1133.0, 1070.0,'DME_ILS'),
		new ChannelFreqObject("47X", 111.0, 1008.0, 1071.0,'VOR'),
		new ChannelFreqObject("47Y", 111.05, 1134.0, 1071.0,'VOR'),
		new ChannelFreqObject("48X", 111.1, 1009.0, 1072.0,'DME_ILS'),
		new ChannelFreqObject("48Y", 111.15, 1135.0, 1072.0,'DME_ILS'),
		new ChannelFreqObject("49X", 111.2, 1010.0, 1073.0,'VOR'),
		new ChannelFreqObject("49Y", 111.25, 1136.0, 1073.0,'VOR'),
		new ChannelFreqObject("50X", 111.3, 1011.0, 1074.0,'DME_ILS'),
		new ChannelFreqObject("50Y", 111.35, 1137.0, 1074.0,'DME_ILS'),
		new ChannelFreqObject("51X", 111.4, 1012.0, 1075.0,'VOR'),
		new ChannelFreqObject("51Y", 111.45, 1138.0, 1075.0,'VOR'),
		new ChannelFreqObject("52X", 111.5, 1013.0, 1076.0,'DME_ILS'),
		new ChannelFreqObject("52Y", 111.55, 1139.0, 1076.0,'DME_ILS'),
		new ChannelFreqObject("53X", 111.6, 1014.0, 1077.0,'VOR'),
		new ChannelFreqObject("53Y", 111.65, 1140.0, 1077.0,'VOR'),
		new ChannelFreqObject("54X", 111.7, 1015.0, 1078.0,'DME_ILS'),
		new ChannelFreqObject("54Y", 111.75, 1141.0, 1078.0,'DME_ILS'),
		new ChannelFreqObject("55X", 111.8, 1016.0, 1079.0,'VOR'),
		new ChannelFreqObject("55Y", 111.85, 1142.0, 1079.0,'VOR'),
		new ChannelFreqObject("56X", 111.9, 1017.0, 1080.0,'DME_ILS'),
		new ChannelFreqObject("56Y", 111.95, 1143.0, 1080.0,'DME_ILS'),
		new ChannelFreqObject("57X", 112.0, 1018.0, 1081.0,'VOR'),
		new ChannelFreqObject("57Y", 112.05, 1144.0, 1081.0,'VOR'),
		new ChannelFreqObject("58X", 112.1, 1019.0, 1082.0,'VOR'),
		new ChannelFreqObject("58Y", 112.15, 1145.0, 1082.0,'VOR'),
		new ChannelFreqObject("59X", 112.2, 1020.0, 1083.0,'VOR'),
		new ChannelFreqObject("59Y", 112.25, 1146.0, 1083.0,'VOR'),
		new ChannelFreqObject("60X", null, 1021.0, 1084.0,null),
		new ChannelFreqObject("60Y", null, 1147.0, 1084.0,null),
		new ChannelFreqObject("61X", null, 1022.0, 1085.0,null),
		new ChannelFreqObject("61Y", null, 1148.0, 1085.0,null),
		new ChannelFreqObject("62X", null, 1023.0, 1086.0,null),
		new ChannelFreqObject("62Y", null, 1149.0, 1086.0,null),
		new ChannelFreqObject("63X", null, 1024.0, 1087.0,null),
		new ChannelFreqObject("63Y", null, 1150.0, 1087.0,null),
		new ChannelFreqObject("64X", null, 1151.0, 1088.0,null),
		new ChannelFreqObject("64Y", null, 1025.0, 1088.0,null),
		new ChannelFreqObject("65X", null, 1152.0, 1089.0,null),
		new ChannelFreqObject("65Y", null, 1026.0, 1089.0,null),
		new ChannelFreqObject("66X", null, 1153.0, 1090.0,null),
		new ChannelFreqObject("66Y", null, 1027.0, 1090.0,null),
		new ChannelFreqObject("67X", null, 1154.0, 1091.0,null),
		new ChannelFreqObject("67Y", null, 1028.0, 1091.0,null),
		new ChannelFreqObject("68X", null, 1155.0, 1092.0,null),
		new ChannelFreqObject("68Y", null, 1029.0, 1092.0,null),
		new ChannelFreqObject("69X", null, 1156.0, 1093.0,null),
		new ChannelFreqObject("69Y", null, 1030.0, 1093.0,null),
		new ChannelFreqObject("70X", 112.3, 1157.0, 1094.0,'VOR'),
		new ChannelFreqObject("70Y", 112.35, 1031.0, 1094.0,'VOR'),
		new ChannelFreqObject("71X", 112.4, 1158.0, 1095.0,'VOR'),
		new ChannelFreqObject("71Y", 112.45, 1032.0, 1095.0,'VOR'),
		new ChannelFreqObject("72X", 112.5, 1159.0, 1096.0,'VOR'),
		new ChannelFreqObject("72Y", 112.55, 1033.0, 1096.0,'VOR'),
		new ChannelFreqObject("73X", 112.6, 1160.0, 1097.0,'VOR'),
		new ChannelFreqObject("73Y", 112.65, 1034.0, 1097.0,'VOR'),
		new ChannelFreqObject("74X", 112.7, 1161.0, 1098.0,'VOR'),
		new ChannelFreqObject("74Y", 112.75, 1035.0, 1098.0,'VOR'),
		new ChannelFreqObject("75X", 112.8, 1162.0, 1099.0,'VOR'),
		new ChannelFreqObject("75Y", 112.85, 1036.0, 1099.0,'VOR'),
		new ChannelFreqObject("76X", 112.9, 1163.0, 1100.0,'VOR'),
		new ChannelFreqObject("76Y", 112.95, 1037.0, 1100.0,'VOR'),
		new ChannelFreqObject("77X", 113.0, 1164.0, 1101.0,'VOR'),
		new ChannelFreqObject("77Y", 113.05, 1038.0, 1101.0,'VOR'),
		new ChannelFreqObject("78X", 113.1, 1165.0, 1102.0,'VOR'),
		new ChannelFreqObject("78Y", 113.15, 1039.0, 1102.0,'VOR'),
		new ChannelFreqObject("79X", 113.2, 1166.0, 1103.0,'VOR'),
		new ChannelFreqObject("79Y", 113.25, 1040.0, 1103.0,'VOR'),
		new ChannelFreqObject("80X", 113.3, 1167.0, 1104.0,'VOR'),
		new ChannelFreqObject("80Y", 113.35, 1041.0, 1104.0,'VOR'),
		new ChannelFreqObject("81X", 113.4, 1168.0, 1105.0,'VOR'),
		new ChannelFreqObject("81Y", 113.45, 1041.0, 1105.0,'VOR'),
		new ChannelFreqObject("82X", 113.5, 1169.0, 1106.0,'VOR'),
		new ChannelFreqObject("82Y", 113.55, 1043.0, 1106.0,'VOR'),
		new ChannelFreqObject("83X", 113.6, 1170.0, 1107.0,'VOR'),
		new ChannelFreqObject("83Y", 113.65, 1044.0, 1107.0,'VOR'),
		new ChannelFreqObject("84X", 113.7, 1171.0, 1108.0,'VOR'),
		new ChannelFreqObject("84Y", 113.75, 1045.0, 1108.0,'VOR'),
		new ChannelFreqObject("85X", 113.8, 1172.0, 1109.0,'VOR'),
		new ChannelFreqObject("85Y", 113.85, 1046.0, 1109.0,'VOR'),
		new ChannelFreqObject("86X", 113.9, 1173.0, 1110.0,'VOR'),
		new ChannelFreqObject("86Y", 113.95, 1047.0, 1110.0,'VOR'),
		new ChannelFreqObject("87X", 114.0, 1174.0, 1111.0,'VOR'),
		new ChannelFreqObject("87Y", 114.05, 1048.0, 1111.0,'VOR'),
		new ChannelFreqObject("88X", 114.1, 1175.0, 1112.0,'VOR'),
		new ChannelFreqObject("88Y", 114.15, 1049.0, 1112.0,'VOR'),
		new ChannelFreqObject("89X", 114.2, 1176.0, 1113.0,'VOR'),
		new ChannelFreqObject("89Y", 114.25, 1050.0, 1113.0,'VOR'),
		new ChannelFreqObject("90X", 114.3, 1177.0, 1114.0,'VOR'),
		new ChannelFreqObject("90Y", 114.35, 1051.0, 1114.0,'VOR'),
		new ChannelFreqObject("91X", 114.4, 1178.0, 1115.0,'VOR'),
		new ChannelFreqObject("91Y", 114.45, 1052.0, 1115.0,'VOR'),
		new ChannelFreqObject("92X", 114.5, 1179.0, 1116.0,'VOR'),
		new ChannelFreqObject("92Y", 114.55, 1053.0, 1116.0,'VOR'),
		new ChannelFreqObject("93X", 114.6, 1180.0, 1117.0,'VOR'),
		new ChannelFreqObject("93Y", 114.65, 1054.0, 1117.0,'VOR'),
		new ChannelFreqObject("94X", 114.7, 1181.0, 1118.0,'VOR'),
		new ChannelFreqObject("94Y", 114.75, 1055.0, 1118.0,'VOR'),
		new ChannelFreqObject("95X", 114.8, 1182.0, 1119.0,'VOR'),
		new ChannelFreqObject("95Y", 114.85, 1056.0, 1119.0,'VOR'),
		new ChannelFreqObject("96X", 114.9, 1183.0, 1120.0,'VOR'),
		new ChannelFreqObject("96Y", 114.95, 1057.0, 1120.0,'VOR'),
		new ChannelFreqObject("97X", 115.0, 1184.0, 1121.0,'VOR'),
		new ChannelFreqObject("97Y", 115.05, 1058.0, 1121.0,'VOR'),
		new ChannelFreqObject("98X", 115.1, 1185.0, 1122.0,'VOR'),
		new ChannelFreqObject("98Y", 115.15, 1059.0, 1122.0,'VOR'),
		new ChannelFreqObject("99X", 115.2, 1186.0, 1123.0,'VOR'),
		new ChannelFreqObject("99Y", 115.25, 1060.0, 1123.0,'VOR'),
		new ChannelFreqObject("100X", 115.3, 1187.0, 1124.0,'VOR'),
		new ChannelFreqObject("100Y", 115.35, 1061.0, 1124.0,'VOR'),
		new ChannelFreqObject("101X", 115.4, 1188.0, 1125.0,'VOR'),
		new ChannelFreqObject("101Y", 115.45, 1062.0, 1125.0,'VOR'),
		new ChannelFreqObject("102X", 115.5, 1189.0, 1126.0,'VOR'),
		new ChannelFreqObject("102Y", 115.55, 1063.0, 1126.0,'VOR'),
		new ChannelFreqObject("103X", 115.6, 1190.0, 1127.0,'VOR'),
		new ChannelFreqObject("103Y", 115.65, 1064.0, 1127.0,'VOR'),
		new ChannelFreqObject("104X", 115.7, 1191.0, 1128.0,'VOR'),
		new ChannelFreqObject("104Y", 115.75, 1065.0, 1128.0,'VOR'),
		new ChannelFreqObject("105X", 115.8, 1192.0, 1129.0,'VOR'),
		new ChannelFreqObject("105Y", 115.85, 1066.0, 1129.0,'VOR'),
		new ChannelFreqObject("106X", 115.9, 1193.0, 1130.0,'VOR'),
		new ChannelFreqObject("106Y", 115.95, 1067.0, 1130.0,'VOR'),
		new ChannelFreqObject("107X", 116.0, 1194.0, 1131.0,'VOR'),
		new ChannelFreqObject("107Y", 116.05, 1068.0, 1131.0,'VOR'),
		new ChannelFreqObject("108X", 116.1, 1195.0, 1132.0,'VOR'),
		new ChannelFreqObject("108Y", 116.15, 1069.0, 1132.0,'VOR'),
		new ChannelFreqObject("109X", 116.2, 1196.0, 1133.0,'VOR'),
		new ChannelFreqObject("109Y", 116.25, 1070.0, 1133.0,'VOR'),
		new ChannelFreqObject("110X", 116.3, 1197.0, 1134.0,'VOR'),
		new ChannelFreqObject("110Y", 116.35, 1071.0, 1134.0,'VOR'),
		new ChannelFreqObject("111X", 116.4, 1198.0, 1135.0,'VOR'),
		new ChannelFreqObject("111Y", 116.45, 1072.0, 1135.0,'VOR'),
		new ChannelFreqObject("112X", 116.5, 1199.0, 1136.0,'VOR'),
		new ChannelFreqObject("112Y", 116.55, 1073.0, 1136.0,'VOR'),
		new ChannelFreqObject("113X", 116.6, 1200.0, 1137.0,'VOR'),
		new ChannelFreqObject("113Y", 116.65, 1074.0, 1137.0,'VOR'),
		new ChannelFreqObject("114X", 116.7, 1201.0, 1138.0,'VOR'),
		new ChannelFreqObject("114Y", 116.75, 1075.0, 1138.0,'VOR'),
		new ChannelFreqObject("115X", 116.8, 1202.0, 1139.0,'VOR'),
		new ChannelFreqObject("115Y", 116.85, 1076.0, 1139.0,'VOR'),
		new ChannelFreqObject("116X", 116.9, 1203.0, 1140.0,'VOR'),
		new ChannelFreqObject("116Y", 116.95, 1077.0, 1140.0,'VOR'),
		new ChannelFreqObject("117X", 117.0, 1204.0, 1141.0,'VOR'),
		new ChannelFreqObject("117Y", 117.05, 1078.0, 1141.0,'VOR'),
		new ChannelFreqObject("118X", 117.1, 1205.0, 1142.0,'VOR'),
		new ChannelFreqObject("118Y", 117.15, 1079.0, 1142.0,'VOR'),
		new ChannelFreqObject("119X", 117.2, 1206.0, 1143.0,'VOR'),
		new ChannelFreqObject("119Y", 117.25, 1080.0, 1143.0,'VOR'),
		new ChannelFreqObject("120X", 117.3, 1207.0, 1144.0,'VOR'),
		new ChannelFreqObject("120Y", 117.35, 1081.0, 1144.0,'VOR'),
		new ChannelFreqObject("121X", 117.4, 1208.0, 1145.0,'VOR'),
		new ChannelFreqObject("121Y", 117.45, 1082.0, 1145.0,'VOR'),
		new ChannelFreqObject("122X", 117.5, 1209.0, 1146.0,'VOR'),
		new ChannelFreqObject("122Y", 117.55, 1083.0, 1146.0,'VOR'),
		new ChannelFreqObject("123X", 117.6, 1210.0, 1147.0,'VOR'),
		new ChannelFreqObject("123Y", 117.65, 1084.0, 1147.0,'VOR'),
		new ChannelFreqObject("124X", 117.7, 1211.0, 1148.0,'VOR'),
		new ChannelFreqObject("124Y", 117.75, 1085.0, 1148.0,'VOR'),
		new ChannelFreqObject("125X", 117.8, 1212.0, 1149.0,'VOR'),
		new ChannelFreqObject("125Y", 117.85, 1086.0, 1149.0,'VOR'),
		new ChannelFreqObject("126X", 117.9, 1213.0, 1150.0,'VOR'),
		new ChannelFreqObject("126Y", 117.95, 1087.0, 1150.0,'VOR'),
  ]

  public static findMaxUpLinkFrequency() : number{
		let max : number = 0;

    for (let i = 0; i < this.channelFreqList.length; i++) {
      if(this.channelFreqList[i].uplinkFreq != null){
				if(this.channelFreqList[i].uplinkFreq > max){
					max = this.channelFreqList[i].uplinkFreq
				}
			}
    }

		return max;
	}

	public static findMinUpLinkFrequency() : number{
		let min : number = 2000;

    for (let i = 0; i < this.channelFreqList.length; i++) {
      if(this.channelFreqList[i].uplinkFreq != null){
				if(this.channelFreqList[i].uplinkFreq < min){
					min = this.channelFreqList[i].uplinkFreq;
				}
			}
    }

		return min;
	}

	public static findUplinkFrequencyByFrequency(frequency : number) : number{
    for (let i = 0; i < this.channelFreqList.length; i++) {
      if(this.channelFreqList[i].vorFreq != null){
				if(this.channelFreqList[i].vorFreq == frequency){
					return this.channelFreqList[i].uplinkFreq;
				}
			}
    }

		return -1;
	}

	/**
	 * Finds channel frequency object by channel
	 * @param channel Channel
	 * @return channel frequency object
	 */
	public static findByChannel (channel : string) : ChannelFreqObject{
		if(channel == null){
			return null;
		}

    for (let i = 0; i < this.channelFreqList.length; i++) {
      if(this.channelFreqList[i].channel.match(channel)){
				return this.channelFreqList[i];
			}
    }

		return null;
	}

	/**
	 * Finds channel frequency object by VOR frequency
	 * @param vorFreq VOR frequency
	 * @return channel frequency object
	 */
	public static findByVorFrequency(vorFreq : number ) : ChannelFreqObject{
		if(vorFreq == null){
			return null;
		}

    for (let i = 0; i < this.channelFreqList.length; i++) {
      if(this.channelFreqList[i].vorFreq != null && vorFreq == this.channelFreqList[i].vorFreq){
				return this.channelFreqList[i];
			}
    }

		return null;
	}

	/**
	 * Gets channel from VOR frequency
	 * @param vorFreq VOR frequency
	 * @return Channel
	 */
	public static getChannelFromVorFrequency(vorFreq : number) : string{
		if(vorFreq == null){
			return null;
		}

    for (let i = 0; i < this.channelFreqList.length; i++) {
      if(this.channelFreqList[i].vorFreq != null && vorFreq == this.channelFreqList[i].vorFreq){
				return this.channelFreqList[i].channel;
			}
    }

		return null;
	}

	/**
	 * Finds channel frequency object by up-link frequency
	 * @param uplinkFreq Up-link frequency
	 * @return Channel frequency object
	 */
	public static findByUplinkFrequency(uplinkFreq : number) : ChannelFreqObject{
		if(uplinkFreq == null){
			return null;
		}

    for (let i = 0; i < this.channelFreqList.length; i++) {
      if(this.channelFreqList[i].uplinkFreq == uplinkFreq){
				return this.channelFreqList[i];
			}
    }

		return null;
	}

	/**
	 * Finds channel frequency object by down-link frequency
	 * @param downlinkFreq Down-link frequency
	 * @return Channel frequency object
	 */
	public static findByDownlinkFrequency(downlinkFreq : number) : ChannelFreqObject{
		if(downlinkFreq == null){
			return null;
		}

    for (let i = 0; i < this.channelFreqList.length; i++) {
      if(this.channelFreqList[i].downlinkFreq  == downlinkFreq){
				return this.channelFreqList[i];
			}
    }

		return null;
	}

}
